import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";

import blueLogo from "../../assets/greedy_logo_blue_350x75.png";
import blueTextLogo from "../../assets/greedy_text_blue_188x54.png";
import whiteLogo from "../../assets/greedy_logo_white_350x75.png";
import whiteTextLogo from "../../assets/greedy_text_white_188x54.png";

import MenuIcon from "@mui/icons-material/Menu";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useLanguageContext } from "../../context/languageContext";
import { textlanguages } from "../../data/textOfThePage";
import { useState } from "react";
import { reportGtagConversion } from "../../utils/tracking";
import { useNavigate } from "react-router-dom";
import { HeaderMenuFlags } from "./HeaderMenuFlags";

export const HeaderComponent = () => {
  const { languageSelected } = useLanguageContext();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    window.location.href = "/";
  };

  const handleWhatsAppClick = () => {
    const openWhatsApp = () => {
      window.open(
        "https://api.whatsapp.com/send/?phone=525512227016&text=Hola%2C+me+gustar%C3%ADa+recibir+m%C3%A1s+informaci%C3%B3n.&type=phone_number&app_absent=0",
        "_blank",
        "noopener,noreferrer"
      );
    };

    // Llama al tracking y le dices qué hacer cuando termine
    reportGtagConversion(openWhatsApp);
  };

  const [navClass, setNavClass] = useState(false);
  const changeNavClass = () => {
    if (window.scrollY >= 10) {
      setNavClass(true);
    } else {
      setNavClass(false);
    }
  };

  window.addEventListener("scroll", changeNavClass);

  const [drawerState, setDrawerState] = useState(false);
  const toggleDrawer = () => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(!drawerState);
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          zIndex: "10",
          width: { xs: "65px", md: "75px" },
          height: { xs: "65px", md: "75px" },
          bgcolor: "#005587",
          right: "2%",
          top: { xs: "90%", md: "85%" },
          borderRadius: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          "&:hover": {
            transform: "scale(1.12)",
            boxShadow: 6,
            cursor: "pointer",
          },
        }}
        onClick={handleWhatsAppClick}
      >
        <WhatsAppIcon sx={{ width: "80%", height: "80%" }} />
      </Box>
      <CssBaseline />
      <AppBar className={navClass ? "navbar-solid" : "navbar-transparent"}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              className="navbar-logo"
              onClick={() => {
                handleLogoClick();
              }}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              <img src={navClass ? blueLogo : whiteLogo} alt="Greedy Logo" />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton size="large" onClick={toggleDrawer()} color="inherit">
                <MenuIcon />
              </IconButton>
            </Box>
            <Box
              className="mobile-navbar-logo"
              onClick={() => {
                handleLogoClick();
              }}
              sx={{ display: { xs: "flex", md: "none" } }}
            >
              <img
                src={navClass ? blueTextLogo : whiteTextLogo}
                alt="Greedy Logo"
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", md: "flex" },
                alignItems: "center",
              }}
            >
              {textlanguages[languageSelected].header.map((section) => (
                <Box
                  key={section.service}
                  onClick={() => {
                    navigate(section.path);
                  }}
                  className="navbar-page"
                >
                  <Typography variant="h6">{section.service}</Typography>
                </Box>
              ))}
              <HeaderMenuFlags />
            </Box>
            <HeaderMenuFlags movileType />
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer anchor={"top"} open={drawerState} onClose={toggleDrawer()}>
        <Box role="presentation">
          <List>
            {textlanguages[languageSelected].header.map((section) => (
              <ListItem key={section} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(section.path);
                  }}
                >
                  <ListItemText primary={section.service}></ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
